import { useState } from 'react'

import conveyorBeltBg from '@/assets/icons/conveyor-belt.png'
import lense from '@/assets/icons/lense.png'
import plmingSearching from '@/assets/icons/plming-searching.png'
import titleSearching from '@/assets/icons/title-searching.png'
import { CONVEYOR_ITEMS } from '@/pages/gacha/steps/constants'

import {
  BeltBackground,
  BottomFill,
  Content,
  ConveyorSection,
  ConveyorTrack,
  ConveyorWrapper,
  FlashLayer,
  LensePositioner,
  Overlay,
  PlmingArea,
  PlmingImage,
  TitleImage,
} from './styles'

const renderSet = (prefix: string) =>
  CONVEYOR_ITEMS.map((item, i) => (
    <img key={`${prefix}-${i}`} src={item.src} alt={item.alt} loading='eager' decoding='async' />
  ))

export default function DrawingOverlay() {
  const [isFlashDone, setIsFlashDone] = useState(false)

  return (
    <>
      {!isFlashDone && <FlashLayer onAnimationEnd={() => setIsFlashDone(true)} />}
      <Overlay>
        <Content>
          <TitleImage src={titleSearching} alt='찾는 중' loading='eager' decoding='async' />
          <PlmingArea>
            <PlmingImage src={plmingSearching} alt='' loading='eager' decoding='async' width={137} height={134} />
            <LensePositioner>
              <img src={lense} alt='' loading='eager' decoding='async' width={140} height={140} />
            </LensePositioner>
          </PlmingArea>
        </Content>

        <ConveyorSection>
          <ConveyorWrapper>
            <ConveyorTrack>
              {renderSet('a')}
              {renderSet('b')}
              {renderSet('c')}
            </ConveyorTrack>
          </ConveyorWrapper>
          <BeltBackground src={conveyorBeltBg} alt='' loading='eager' decoding='async' />
          <BottomFill />
        </ConveyorSection>
      </Overlay>
    </>
  )
}
